import type { PayloadAction } from "@reduxjs/toolkit";
import type { UpnpSettingsState } from "Interfaces";
import { createAppSlice } from "Data/Redux/Store";

const initialState: UpnpSettingsState = {
	upnp: false,
	friendlyName: ""
};

export const setUpnpReducer = (state: UpnpSettingsState, action: PayloadAction<UpnpSettingsState>) => {
	return action.payload;
};

export const getUpnp = (state: UpnpSettingsState) => {
	return state;
};

const upnpSlice = createAppSlice({
	name: "upnp",
	initialState,
	reducers: {
		setUpnpAction: setUpnpReducer
	},
	selectors: {
		selectUpnp: getUpnp
	}
});

export default upnpSlice;

export const { setUpnpAction } = upnpSlice.actions;
export const { selectUpnp } = upnpSlice.selectors;
